interface StyleSize {
    value: number;
    unit: string;
    isDefault: boolean;
}

const textAnnotationFontSizes: StyleSize[] = [
    { value: 8, unit: "pt", isDefault: false },
    { value: 10, unit: "pt", isDefault: false },
    { value: 12, unit: "pt", isDefault: true },
    { value: 16, unit: "pt", isDefault: false },
    { value: 24, unit: "pt", isDefault: false },
    { value: 32, unit: "pt", isDefault: false }
];

const highlightAnnotationStrokeSizes: StyleSize[] = [
    { value: 10, unit: "px", isDefault: true },
    { value: 20, unit: "px", isDefault: false },
    { value: 30, unit: "px", isDefault: false }
];

const pencilAnnotationStrokeSizes: StyleSize[] = [
    { value: 2, unit: "px", isDefault: true },
    { value: 5, unit: "px", isDefault: false },
    { value: 10, unit: "px", isDefault: false }
];

function formatAnnotationStyleSize(styleSize: StyleSize): string {
    return `${styleSize.value}${styleSize.unit}`;
}

export { formatAnnotationStyleSize, highlightAnnotationStrokeSizes, pencilAnnotationStrokeSizes, StyleSize, textAnnotationFontSizes };
